import template from './dateTimeField.html';
import controller from './dateTimeField.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
    onUpdate: '&',
  }
};

export default component;
